<ng-container *ngIf="filterChips.length > 0">
  <div fxLayout="row wrap" fxLayoutAlign="start start" *ngFor="let filterChip of filterChips">
    <ng-container class="filter-wrapper">
      <ng-container *ngIf="displayBlockTriangle">
        <div
          data-cy="{{ filterChip.type | displayTranslation }}"
          class="block"
          (click)="toggleTypeExpanded(filterChip)"
          [ngClass]="{ expanded: filterChip.typeExpanded, twoLine: filterChip.twoLineDisplay }"
        >
          {{ filterChip.type | displayTranslation }}
        </div>
        <div class="block-triangle" [ngClass]="{ twoLine: filterChip.twoLineDisplay }"></div>
      </ng-container>

      <ng-container *ngFor="let chip of filterChip.data; let i = index">
        <div
          *ngIf="i < 3"
          [attr.data-cy]="chip.text | displayTranslation"
          class="chip-container margin-left-1"
          [ngClass]="{ expanded: chip.expanded }"
          (click)="toggleExpanded(chip)"
        >
          {{ chip.text | displayTranslation }}
        </div>
      </ng-container>

      <div *ngIf="filterChip.data.length > 3" class="chip-container margin-left-1 count-badge">
        +{{ filterChip.data.length - 3 }}
      </div>
    </ng-container>
  </div>
</ng-container>
